import React, { useState, useEffect, useCallback, useRef, useMemo } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { mobileObjectDetailService } from '../services/mobileObjectDetailService';
import { mobileSatsueiService } from '../services/mobileSatsueiService';
import { useApiError } from '../../shared/hooks/useApiError';
import { useAuth } from '../../shared/auth';
import { mobileUserInfoService } from '../services/mobileUserInfoService';
import { MessageDialog } from '../../shared/ui';
import Footer from '../components/Footer';
import ImageTagListModal from '../components/ImageTagListModal';
import ImageReshootModal from '../components/ImageReshootModal';
import ImageCaptureFromPositionModal from '../components/ImageCaptureFromPositionModal';
import ImageDeleteModal from '../components/ImageDeleteModal';
import ImageSwapModal from '../components/ImageSwapModal';
import MovieReshootModal from '../components/MovieReshootModal';
import MovieDeleteModal from '../components/MovieDeleteModal';
import ShareModal from '../components/ShareModal';
import ImageHandwriteEditModal from '../components/ImageHandwriteEditModal';
import SatsueiMemoForm from '../components/SatsueiMemoForm';

/**
 * AppObjectDetailコンポーネントのスタイル定義
 * オブジェクト詳細画面の全体的なレイアウトと各要素のスタイルを定義
 */
const styles = {
  // メインコンテナ
  container: {
    height: '100%',
    display: 'block',
    overflowY: 'scroll',
    WebkitOverflowScrolling: 'touch'
  },
  // ローディング画面
  loading: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    background: 'white',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 9999
  },
  // ヘッダー部分
  detailHeader: {
    width: '100%',
    height: '40px',
    background: '#444',
    position: 'fixed',
    top: 0,
    zIndex: 1000
  },
  // ヘッダー左側エリア
  headerLeft: {
    float: 'left'
  },
  // 戻るボタン
  showList: {
    width: '32px',
    height: '32px',
    margin: '5px 6px',
    display: 'inline-block',
    backgroundImage: 'url("/core/img/icon/back-arrow-button.png")',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'contain',
    float: 'left',
    cursor: 'pointer'
  },
  // オブジェクトID表示エリア
  objectIdArea: {
    margin: '7px 0 0 14px',
    display: 'inline-block'
  },
  // オブジェクトIDタイトル
  objectIdAreaTitle: {
    color: '#FFF',
    background: '#2B2222',
    fontWeight: 'bold',
    fontSize: '8pt',
    padding: '4px 12px',
    textAlign: 'center',
    float: 'left',
    border: '1px solid #FFF'
  },
  // オブジェクトID値
  objectIdAreaBody: {
    color: '#2B2222',
    background: '#FFF',
    fontWeight: 'bold',
    fontSize: '8pt',
    float: 'left',
    padding: '4px 12px',
    textAlign: 'center',
    minWidth: '60px',
    border: '1px solid #FFF'
  },
  imageMainAreaHeader: {
    position: 'relative',
    top: '40px'
  },
  switchImageButtonArea: {
    padding: '6px',
    backgroundColor: '#2B2222',
    float: 'left',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer'
  },
  switchImageButton: {
    width: '32px',
    height: '32px',
    display: 'inline-block',
    backgroundImage: 'url("/core/img/icon/icon-photo-camera.png")',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'contain',
    backgroundPosition: 'center'
  },
  switchMovieButtonArea: {
    padding: '6px',
    backgroundColor: '#EEE',
    float: 'left',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer'
  },
  switchMovieButton: {
    width: '32px',
    height: '32px',
    display: 'inline-block',
    backgroundImage: 'url("/core/img/icon/icon-video-camera.png")',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'contain',
  },
  imageShare: {
    width: '35px',
    height: '35px',
    margin: '4px',
    display: 'inline-block',
    backgroundImage: 'url("/core/img/icon/share_black.png")',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'contain',
    float: 'left',
    cursor: 'pointer'
  },
  imageEdit: {
    width: '35px',
    height: '35px',
    margin: '4px',
    display: 'inline-block',
    backgroundImage: 'url("/core/img/imageedit.png")',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'contain',
    float: 'left',
    cursor: 'pointer'
  },
  imageArea: {
    position: 'relative',
    top: '40px'
  },
  movieArea: {
    position: 'relative',
    top: '40px'
  },
  imageMainAreaTop: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: '4px',
    backgroundColor: '#000'
  },
  satsueiKanryoJikoku: {
    fontSize: '11px',
    color: '#FFF'
  },
  satsueiMaisu: {
    fontSize: '11px',
    color: '#FFF'
  },
  imageMainArea: {
    position: 'relative',
    textAlign: 'center',
    width: '100%',
    backgroundColor: '#F5F5F5',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  imageMainAreaMisatsuei: {
    position: 'relative',
    textAlign: 'center',
    width: '100%',
    backgroundColor: '#2B2222',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  misatsuei: {
    backgroundColor: '#DDD',
    border: '1px solid #FFF',
    margin: '20px auto',
    width: '90%'
  },
  message: {
    fontSize: '16px',
    color: '#666',
    margin: '40px 5px 10px'
  },
  satsueiStart: {
    padding: '10px 20px',
    background: '#F93535',
    color: 'white',
    border: 'none',
    borderRadius: '5px',
    cursor: 'pointer',
    fontSize: '14px',
    margin: '10px 5px 40px'
  },
  imageMain: {
    maxWidth: '100%',
    maxHeight: '70vh',
    objectFit: 'contain',
    display: 'block',
    margin: '0 auto'
  },
  imageTagArea: {
    padding: '8px 10px',
    background: '#f9f9f9',
    borderTop: '1px solid #ddd',
    borderBottom: '1px solid #ddd'
  },
  imageTag: {
    fontSize: '12px',
    color: '#333',
    display: 'flex',
    flexWrap: 'wrap',
    gap: '4px'
  },
  tagItem: {
    display: 'inline-block',
    background: '#e0e0e0',
    color: '#333',
    padding: '2px 8px',
    borderRadius: '12px',
    fontSize: '11px',
    margin: '1px'
  },
  imageMainAreaBottom: {
    padding: '4px',
    background: '#000'
  },
  satsueiBasho: {
    fontSize: '11px',
    color: '#FFF',
    textAlign: 'right'
  },
  imageThumbnailArea: {
    padding: '8px 4px',
    overflowX: 'auto',
    WebkitOverflowScrolling: 'touch'
  },
  imageThumbnail: {
    listStyle: 'none',
    padding: 0,
    margin: 0,
    display: 'flex',
    overflowX: 'auto'
  },
  thumbnailItem: {
    flex: '0 0 auto',
    width: '70px',
    height: '70px',
    border: '2px solid #ddd',
    borderRadius: '5px',
    cursor: 'pointer',
    overflow: 'hidden'
  },
  thumbnailImage: {
    width: '100%',
    height: '100%',
    objectFit: 'cover'
  },
  movieMainArea: {
    position: 'relative',
    textAlign: 'center',
    width: '100%',
    aspectRatio: '1',
    backgroundColor: '#2B2222',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  movieMainAreaTop: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: '4px',
    backgroundColor: '#000'
  },
  movieMainAreaBottom: {
    padding: '4px',
    background: '#000'
  },
  movieMainAreaMisatsuei: {
    position: 'relative',
    textAlign: 'center',
    width: '100%',
    backgroundColor: '#2B2222',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  movieSatsueiStart: {
    padding: '10px 20px',
    background: '#F93535',
    color: 'white',
    border: 'none',
    borderRadius: '5px',
    cursor: 'pointer',
    fontSize: '14px',
    margin: '10px 5px 40px'
  },
  movieMain: {
    maxWidth: '100%',
    maxHeight: '100%',
    objectFit: 'contain',
    display: 'block'
  },
  movieThumbnailArea: {

  },
  movieThumbnail: {
    listStyle: 'none',
    padding: 0,
    margin: 0,
    display: 'flex',
    overflowX: 'auto'
  },
  movieThumbnailItem: {
    flex: '0 0 auto',
    width: '70px',
    height: '70px',
    border: '2px solid #ddd',
    borderRadius: '5px',
    cursor: 'pointer',
    overflow: 'hidden',
    position: 'relative'
  },
  movieThumbnailImage: {
    width: '100%',
    height: '100%',
    objectFit: 'contain',
    background: '#2B2222'
  },
  moviePlayIcon: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '20px',
    height: '20px',
    backgroundImage: 'url("/core/img/icon/play-icon.png")',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'contain',
    backgroundPosition: 'center'
  },
  selector: {
    padding: '20px 20px 1px 20px',
    background: 'white',
    position: 'relative',
    top: '40px',
  },
  satsueiMemoCategoryArea: {
    marginBottom: '20px'
  },
  satsueiMemoCategoryAreaTitle: {
    fontSize: '14px',
    fontWeight: 'bold',
    marginBottom: '10px',
    color: '#333',
    backgroundColor: '#FFE4E1',
    padding: '5px 10px',
    borderRadius: '3px'
  },
  select: {
    width: '100%',
    padding: '12px',
    border: '1px solid #ddd',
    borderRadius: '5px',
    fontSize: '14px',
    backgroundColor: 'white'
  },
  satsueiGuideArea: {
    marginBottom: '20px'
  },
  satsueiGuideAreaTitle: {
    fontSize: '14px',
    fontWeight: 'bold',
    marginBottom: '10px',
    color: '#333',
    backgroundColor: '#FFE4E1',
    padding: '5px 10px',
    borderRadius: '3px'
  },
  kyotenListArea: {
    marginBottom: '20px'
  },
  kyotenListAreaTitle: {
    fontSize: '14px',
    fontWeight: 'bold',
    marginBottom: '10px',
    color: '#333',
    backgroundColor: '#FFE4E1',
    padding: '5px 10px',
    borderRadius: '3px'
  },
  satsueiMemoArea: {
    padding: '20px',
    background: 'white',
    marginBottom: '70px'
  },
  satsueiMemoForm: {
    marginBottom: '20px'
  },
  satsueiMemoFormUl: {
    listStyle: 'none',
    padding: 0,
    margin: 0
  },
  satsueiMemoFormLi: {
    marginBottom: '15px'
  },
  satsueiMemoFormLabel: {
    fontSize: '16px',
    fontWeight: 'bold',
    marginBottom: '10px',
    color: '#333',
    backgroundColor: '#FFE4E1',
    padding: '8px 12px',
    borderRadius: '5px',
    display: 'block'
  },
  satsueiMemoFormColumn: {
    marginBottom: '15px'
  },
  satsueiMemoFormTitle: {
    fontSize: '14px',
    fontWeight: 'bold',
    marginBottom: '8px',
    color: '#333'
  },
  satsueiMemoFormValue: {
    marginBottom: '10px'
  },
  satsueiMemoFormInput: {
    width: '100%',
    padding: '10px',
    border: '1px solid #ddd',
    borderRadius: '5px',
    fontSize: '14px',
    boxSizing: 'border-box'
  },
  satsueiMemoFormTextarea: {
    width: '100%',
    padding: '10px',
    border: '1px solid #ddd',
    borderRadius: '5px',
    fontSize: '14px',
    resize: 'vertical',
    minHeight: '80px',
    boxSizing: 'border-box'
  },
  satsueiMemoFormSelect: {
    width: '100%',
    padding: '10px',
    border: '1px solid #ddd',
    borderRadius: '5px',
    fontSize: '14px',
    backgroundColor: 'white',
    boxSizing: 'border-box'
  },
  satsueiMemoFormRadioGroup: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '10px'
  },
  satsueiMemoFormRadio: {
    display: 'flex',
    alignItems: 'center',
    padding: '8px 12px',
    border: '1px solid #ddd',
    borderRadius: '5px',
    cursor: 'pointer',
    backgroundColor: '#fefdf5',
    transition: 'all 0.2s ease'
  },
  satsueiMemoFormRadioChecked: {
    backgroundColor: '#FDD',
    borderColor: '#FAA'
  },
  satsueiMemoFormCheckbox: {
    display: 'flex',
    alignItems: 'center',
    padding: '8px 12px',
    border: '1px solid #ddd',
    borderRadius: '5px',
    cursor: 'pointer',
    backgroundColor: '#fefdf5',
    transition: 'all 0.2s ease',
    marginBottom: '5px'
  },
  satsueiMemoFormCheckboxChecked: {
    backgroundColor: '#FDD',
    borderColor: '#FAA'
  },
  satsueiMemoAreaTitle: {
    fontSize: '14px',
    fontWeight: 'bold',
    marginBottom: '10px',
    color: 'white',
    backgroundColor: 'black',
    marginTop: '25px',
    padding: '5px 10px'
  },
  registMemo: {
    display: 'block',
    background: '#f93535',
    borderRadius: '30px',
    padding: '10px 15px 10px 20px',
    position: 'fixed',
    bottom: '80px',
    right: '10px',
    letterSpacing: '5px',
    color: 'white',
    fontSize: '16px'
  },
  copyObject: {
    display: 'block',
    background: '#4c5372',
    fontSize: '10pt',
    borderRadius: '30px',
    padding: '8px 18px 8px 21px',
    position: 'fixed',
    bottom: '130px',
    right: '10px',
    letterSpacing: '3px',
    color: 'white'
  },
  delete: {
    padding: '7px 15px',
    background: '#dc3545',
    color: 'white',
    border: 'none',
    borderRadius: '5px',
    cursor: 'pointer',
    fontSize: '14px',
    margin: '4px 8px'
  },
  imageEditArea: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    background: 'rgba(0, 0, 0, 0.8)',
    zIndex: 2000,
    display: 'none',
    alignItems: 'center',
    justifyContent: 'center'
  },
  imageEditContent: {
    background: 'white',
    padding: '20px',
    borderRadius: '10px',
    maxWidth: '90%',
    maxHeight: '90%',
    overflow: 'auto'
  },
  imageEditButton: {
    display: 'block',
    width: '100%',
    padding: '15px',
    margin: '10px 0',
    background: '#f8f9fa',
    border: '1px solid #ddd',
    borderRadius: '5px',
    cursor: 'pointer',
    fontSize: '14px',
    textAlign: 'left'
  },
  closeImageEdit: {
    padding: '10px 20px',
    background: '#666',
    color: 'white',
    border: 'none',
    borderRadius: '5px',
    cursor: 'pointer',
    fontSize: '14px',
    marginBottom: '20px'
  },
  modal: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    background: 'rgba(0, 0, 0, 0.5)',
    zIndex: 3000,
    display: 'none',
    alignItems: 'center',
    justifyContent: 'center'
  },
  modalContent: {
    background: 'white',
    padding: '20px',
    borderRadius: '10px',
    maxWidth: '90%',
    maxHeight: '90%',
    overflow: 'auto'
  },
  modalInput: {
    width: '100%',
    padding: '12px',
    border: '1px solid #ddd',
    borderRadius: '5px',
    fontSize: '14px',
    marginBottom: '10px'
  },
  modalButton: {
    padding: '10px 20px',
    background: '#F93535',
    color: 'white',
    border: 'none',
    borderRadius: '5px',
    cursor: 'pointer',
    fontSize: '14px'
  },
  modalCancelButton: {
    padding: '10px 20px',
    background: '#666',
    color: 'white',
    border: 'none',
    borderRadius: '5px',
    cursor: 'pointer',
    fontSize: '14px'
  }
};

/**
 * AppObjectDetailコンポーネント
 * オブジェクトの詳細表示、画像・動画の管理、撮影メモの登録を行うメインコンポーネント
 * 
 * @param {Function} onClose - コンポーネントを閉じる際のコールバック関数
 */
const AppObjectDetail = ({ 
  onClose
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useAuth();
  const [thetaCameraUsage, setThetaCameraUsage] = useState(0);

  // APIエラーハンドリングフック
  const { 
    handleApiError,
    showErrorDialog,
    errorMessage,
    closeErrorDialog
  } = useApiError(() => setIsLoading(false));

  // 関数の参照を安定化
  const handleApiErrorRef = useRef(handleApiError);

  useEffect(() => {
    handleApiErrorRef.current = handleApiError;
  }, [handleApiError]);

  // THETA利用可否を取得
  useEffect(() => {
    const loadThetaUsage = async () => {
      try {
        const pixUserResponse = await mobileUserInfoService.getPixUser(user);
        if (pixUserResponse?.returnCode === '200' && pixUserResponse.pixUserList?.length > 0) {
          const usage = pixUserResponse.pixUserList[0].thetaCameraUsage;
          setThetaCameraUsage(Number(usage) === 1 ? 1 : 0);
        }
      } catch (_) {}
    };
    if (user) loadThetaUsage();
  }, [user]);

  // URLパラメータからobjectIdを取得
  const urlParams = new URLSearchParams(location.search);
  const objectIdAutoFlg = urlParams.get('objectIdAutoFlg') || '0'; // オブジェクトID自動生成フラグ
  const objectId = urlParams.get('objectId'); // オブジェクトID
  const resolvedFromPage = urlParams.get('from') || 'search'; // 遷移元ページ
  
  // 基本状態管理
  const [selectFlg, setSelectFlg] = useState(0); // 表示モード（0: 画像, 1: 動画）
  const [imageLength, setImageLength] = useState(0); // 画像枚数
  const [odIsUploaded, setOdIsUploaded] = useState(1); // アップロード完了フラグ
  const [isLoading, setIsLoading] = useState(false); // ローディング状態
  
  // ポーリング関連の状態管理
  const [pollingInterval, setPollingInterval] = useState(null); // ポーリング間隔
  const [duringPolling, setDuringPolling] = useState(false); // ポーリング中フラグ
  
  // モーダル表示状態管理
  const [showImageEdit, setShowImageEdit] = useState(false); // 画像編集モーダル表示フラグ
  const [showCopyModal, setShowCopyModal] = useState(false); // コピーモーダル表示フラグ
  const [showImageTagListModal, setShowImageTagListModal] = useState(false); // 画像タグリストモーダル表示フラグ
  const [showImageReshootModal, setShowImageReshootModal] = useState(false); // 画像再撮影モーダル表示フラグ
  const [showImageCaptureFromPositionModal, setShowImageCaptureFromPositionModal] = useState(false); // 指定位置撮影モーダル表示フラグ
  const [showImageDeleteModal, setShowImageDeleteModal] = useState(false); // 画像削除モーダル表示フラグ
  const [showImageSwapModal, setShowImageSwapModal] = useState(false); // 画像入れ替えモーダル表示フラグ
  const [showImageHandwriteEditModal, setShowImageHandwriteEditModal] = useState(false); // 画像手書き編集モーダル表示フラグ
  const [showMovieReshootModal, setShowMovieReshootModal] = useState(false); // 動画再撮影モーダル表示フラグ
  const [showMovieDeleteModal, setShowMovieDeleteModal] = useState(false); // 動画削除モーダル表示フラグ
  const [showShareModal, setShowShareModal] = useState(false); // シェアモーダル表示フラグ
  
  // シェア・コピー関連の状態管理
  const [shareData, setShareData] = useState(null); // シェアデータ
  const [copyDestinationObjectId, setCopyDestinationObjectId] = useState(''); // コピー先オブジェクトID
  const [copyButtonDisabled, setCopyButtonDisabled] = useState(false); // コピーボタン無効フラグ
  const [copyButtonText, setCopyButtonText] = useState('コピー'); // コピーボタンテキスト
  const [copyInputDisabled, setCopyInputDisabled] = useState(false); // コピー入力無効フラグ
  
  // 撮影関連の設定データ
  const [backUrl, setBackUrl] = useState(''); // 戻り先URL
  const [isSaveLocal, setIsSaveLocal] = useState(''); // ローカル保存フラグ
  const [userKyotenId, setUserKyotenId] = useState(''); // ユーザー拠点ID
  
  // フォーム入力データ
  const [satsueiMemoCategory, setSatsueiMemoCategory] = useState('0'); // 撮影メモカテゴリー
  const [satsueiGuide, setSatsueiGuide] = useState(''); // 撮影ガイド
  const [kyoten, setKyoten] = useState('0'); // 拠点
  const [hozonFolder, setHozonFolder] = useState(0); // 保存フォルダ
  
  // 撮影メモフォーム関連の状態管理
  const [satsueiMemoColumns, setSatsueiMemoColumns] = useState([]); // 撮影メモカラム定義
  const [satsueiMemoFormData, setSatsueiMemoFormData] = useState({}); // 撮影メモフォームデータ
  const [formChangeFlg, setFormChangeFlg] = useState(false); // フォーム変更フラグ
  
  // オブジェクトデータの存在確認
  const [hasObjectData, setHasObjectData] = useState(false);
  
  // 画像・動画データの状態管理
  const [images, setImages] = useState([]); // 画像URL配列
  const [imageData, setImageData] = useState([]); // 画像の詳細データ（サムネイル用）
  const [currentImageIndex, setCurrentImageIndex] = useState(0); // 現在選択中の画像インデックス
  const [movies, setMovies] = useState([]); // 動画データ配列
  const [movieData, setMovieData] = useState([]); // 動画の詳細データ（サムネイル用）
  const [currentMovieIndex, setCurrentMovieIndex] = useState(0); // 現在選択中の動画インデックス
  const [movieUrl, setMovieUrl] = useState(''); // 現在の動画URL
  const [imageTags, setImageTags] = useState({}); // 画像タグデータ
  const [folderImageCounts, setFolderImageCounts] = useState({}); // 各フォルダの画像枚数
  const [totalImageCount, setTotalImageCount] = useState(0); // 全画像枚数
  
  // Refs（DOM要素や関数への参照）
  const pollingIntervalRef = useRef(null); // ポーリング間隔のref
  const satsueiMemoFormRef = useRef(null); // 撮影メモフォームのref
  
  // ドロップダウンオプションの状態管理
  const [satsueiMemoCategories, setSatsueiMemoCategories] = useState([]); // 撮影メモカテゴリーリスト
  const [satsueiGuides, setSatsueiGuides] = useState([]); // 撮影ガイドリスト
  const [kyotenLists, setKyotenLists] = useState([]); // 拠点リスト
  const [hozonFolders, setHozonFolders] = useState([]); // 保存フォルダリスト

  // コンポーネント初期化
  useEffect(() => {
    const initializeData = async () => {
      setIsLoading(true);

      try {
        // 初期表示用データを取得
        const initialData = await mobileSatsueiService.getInitialData({});

        if(initialData.returnCode !== '200'){
          MessageDialog.show('エラー', '撮影データの取得に失敗しました。', null, 'error');
          setIsLoading(false);
          return;
        }
        
        // 取得したデータでstateを更新
        if (initialData.backUrl!=='') {
          setBackUrl(initialData.backUrl);
        }
        if (initialData.isSaveLocal!=='') {
          setIsSaveLocal(initialData.isSaveLocal);
        }
        if(initialData.userKyotenId!=='') {
          setUserKyotenId(initialData.userKyotenId);
        }

        if (objectId) {
          await loadOd();
          await loadImage(); // 画像読み込み
          await loadMovie();
         }
        
      } catch (error) {
        handleApiError(new Error('撮影データの取得に失敗しました。'));
      } finally {
        setIsLoading(false);
      }
    };

    initializeData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [objectId]);

  // コンポーネントアンマウント時のクリーンアップ
  useEffect(() => {
    // ページ離脱時のイベントリスナーを追加
    const handleBeforeUnload = () => {
      stopAllPollingProcesses();
    };

    // beforeunloadイベントリスナーを追加
    window.addEventListener('beforeunload', handleBeforeUnload);
    
    return () => {
      // 全てのpollingプロセスを確実に停止
      stopAllPollingProcesses();
      
      // イベントリスナーを削除
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // 依存配列を空にして、常に最新のrefを参照

  // 撮影ガイドリストの読み込み
  const loadSatsueiGuideList = useCallback(async (categoryId) => {
    try {
      // まず撮影ガイドをクリア
      setSatsueiGuides([]);
      
      const guides = await mobileObjectDetailService.getSatsueiGuides(categoryId);

      if(guides.returnCode !== '200'){
        MessageDialog.show('エラー', '撮影ガイドの取得に失敗しました。', null, 'error');
        return;
      }
      setSatsueiGuides(Array.isArray(guides.satsueiGuideList) ? guides.satsueiGuideList : []);
    } catch (error) {
      handleApiError(new Error('撮影ガイドの取得に失敗しました。'));
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // 撮影メモカテゴリー変更時の処理
  useEffect(() => {
    if (satsueiMemoCategory != null && satsueiMemoCategory !== '') {
      loadSatsueiGuideList(satsueiMemoCategory);
    } else {
      // カテゴリーが選択されていない場合は撮影ガイドをリセット
      setSatsueiGuides([]);
      setSatsueiGuide('');
    }
  }, [satsueiMemoCategory, loadSatsueiGuideList]);

  /**
   * オブジェクト詳細データの読み込み
   * オブジェクトの基本情報、撮影メモカテゴリー、拠点、画像フォルダなどの情報を取得
   */
  const loadOd = async () => {
    try {
      // まず撮影メモカテゴリー、拠点、画像フォルダを取得
      const [categories, kyoten, folders] = await Promise.all([
        mobileObjectDetailService.getSatsueiMemoCategories(),
        mobileObjectDetailService.getKyotenLists(),
        mobileObjectDetailService.getImageFolders()
      ]);
      
      // ドロップダウンオプションの設定
      if (categories) {
        setSatsueiMemoCategories(Array.isArray(categories.satsueiMemoCategoryList) ? categories.satsueiMemoCategoryList : []);
      }
      if (kyoten) {
        setKyotenLists(Array.isArray(kyoten.kyotenList) ? kyoten.kyotenList : []);
      }
      if (folders) {
        const folderList = Array.isArray(folders.imageFolderList) ? folders.imageFolderList : [];
        setHozonFolders(folderList);
        
        // 各フォルダの画像枚数を計算
        if (folderList.length > 0) {
          await calculateFolderImageCounts(folderList);
        }
      }
      
      // その後、オブジェクト情報を取得
      const objectData = await mobileObjectDetailService.getObjectDetail(objectId, null);

      if(objectData.returnCode !== '200'){
        MessageDialog.show('エラー', '撮影データの取得に失敗しました。', null, 'error');
        return;
      }
      // オブジェクトデータの設定
      if (objectData) {
        const object = objectData;
        
        // objectDataが存在する場合のフラグを設定
        if(objectData.createDatetime && objectData.createDatetime !== ''){
          setHasObjectData(true);
        } else {
          setHasObjectData(false);
        }
        
        // 基本情報の設定
        setSatsueiMemoCategory(object.satsueiMemoCategoryId != null && 
          object.satsueiMemoCategoryId !== '' ? String(object.satsueiMemoCategoryId) : '0')
        setSatsueiGuide(object.satsueiGuideId || '');
        setKyoten(object.kyotenId || '0');
        setHozonFolder(object.imageFolderId != null ? object.imageFolderId : 0)
        
        // 画像・動画情報の設定
        setImages(object.objectImages || []);
        setImageLength(object.objectImages?.length || 0);
        
        // 撮影メモカラムの設定
        setSatsueiMemoColumns(object.satsueiMemoColumnDataList || []);
      } else {
        // objectDataが存在しない場合のフラグを設定
        setHasObjectData(false);
      }
      
      // 撮影ガイドの読み込み（撮影メモカテゴリが設定されている場合）
      if (objectData) {
        const satsueiMemoCategoryId = objectData.satsueiMemoCategoryId;
        if (satsueiMemoCategoryId != null) {
          try {
            const guides = await mobileObjectDetailService.getSatsueiGuides(satsueiMemoCategoryId);

            if(guides.returnCode !== '200'){
              MessageDialog.show('エラー', '撮影ガイドの取得に失敗しました。', null, 'error');
            }

            setSatsueiGuides(Array.isArray(guides.satsueiGuideList) ? guides.satsueiGuideList : []);
        } catch (error) {
          setSatsueiGuides([]);
        }
        }
      }
      
    } catch (error) {
      handleApiError(new Error('撮影データの取得に失敗しました。'));
    }
  };


  // 撮影メモカテゴリー変更時の処理
  const handleSatsueiMemoCategoryChange = async (categoryId) => {
    try {
      setSatsueiMemoCategory(categoryId);
      
      // 撮影ガイドの再読み込み
      if (categoryId) {
        await loadSatsueiGuideList(categoryId);
      } else {
        setSatsueiGuides([]);
        setSatsueiGuide('');
      }
      
      // 撮影メモフォームの再読み込み
      if (categoryId) {
        try {
          const objectData = await mobileObjectDetailService.getObjectDetail(objectId, categoryId);

          if(objectData.returnCode !== '200'){
            MessageDialog.show('エラー', '撮影データの取得に失敗しました。', null, 'error');
            return;
          }

          if (objectData) {
            // 撮影メモカラムの設定
            setSatsueiMemoColumns(objectData.satsueiMemoColumnDataList || []);
          }
        } catch (error) {
          setSatsueiMemoColumns([]);
        }
      }
    } catch (error) {
      handleApiError(new Error('撮影メモの取得に失敗しました。'));
    }
  };


  // 各フォルダの画像枚数を計算する関数
  const calculateFolderImageCounts = async (folders) => {
    try {
      const counts = {};
      let totalCount = 0;
      
      // 全フォルダの画像枚数を取得
      for (const folder of folders) {
        const folderId = folder.imageFolderId;
        const imageData = await mobileObjectDetailService.getObjectImageList(objectId, folderId);
        
        if (imageData && imageData.objectDatas && imageData.objectDatas.length > 0) {
          const objectImages = imageData.objectDatas[0].objectImages;
          const folderCount = objectImages ? objectImages.length : 0;
          counts[folderId] = folderCount;
          totalCount += folderCount;
        } else {
          counts[folderId] = 0;
        }
      }
      
      setFolderImageCounts(counts);
      setTotalImageCount(totalCount);
    } catch (error) {
      // エラーログは削除（本番環境では不要）
    }
  };

  /**
   * 画像データの読み込み
   * 指定されたフォルダの画像一覧を取得し、blob形式で表示用URLを生成
   * @param {number} folderId - フォルダID（指定されない場合はhozonFolderを使用）
   */
  const loadImage = async (folderId = null) => {
    try {
      // 画像一覧を取得（folderIdが指定されていない場合はhozonFolderを使用）
      let targetFolderId = folderId || hozonFolder || 99;

      // 「保存フォルダを選択」の場合は全画像を表示（フォルダIDを99に設定）
      if (!targetFolderId) {
        targetFolderId = 99;
      }
      
      const imageData = await mobileObjectDetailService.getObjectImageList(objectId, targetFolderId);

      if(imageData.returnCode !== '200'){
        MessageDialog.show('エラー', '画像の取得に失敗しました。', null, 'error');
        return;
      }

      let noUploadedCount = 0;
      let uploadedCount = 0;
      
      if (imageData && imageData.objectDatas && imageData.objectDatas.length > 0) {
        const objectImages = imageData.objectDatas[0].objectImages;
        
        if (objectImages && objectImages.length > 0) {


          // 画像データをblobとして取得（AppSearch.jsxと同じ方法）
          const imagePromises = objectImages.map(async (image, index) => {
            if (image.isUploaded === 0) {
              noUploadedCount++;

              // アップロード未完了の画像: プレースホルダーアイコンを表示
              return {
                ...image,
                imageIndex: index,
                mainImageUrl: '/core/img/sendingimage.png',
                thumbnailUrl: '/core/img/sendingimage.png'
              };
            } else if (image.objectImageId !== undefined 
              && image.objectImageId !== null && image.objectImageId !== '') {

              uploadedCount++;

              // アップロード済みの画像（blob）
              try {
                const blobUrl = await mobileObjectDetailService.getImageAsBlob(
                  image.objectId,
                  image.objectImageId,
                  image.objectImageEditId,
                  image.filenameExtension,
                  image.isUploaded
                );
                return {
                  ...image,
                  imageIndex: index,
                  mainImageUrl: blobUrl,
                  thumbnailUrl: blobUrl
                };
              } catch (error) {
                return {
                  ...image,
                  imageIndex: index,
                  mainImageUrl: '/core/img/errorimage.png',
                  thumbnailUrl: '/core/img/errorimage.png'
                };
              }
            } else {
              uploadedCount++;

              // 画像がない場合
              return {
                ...image, 
                imageIndex: index,
                mainImageUrl: '/core/img/misatsuei.png',
                thumbnailUrl: '/core/img/misatsuei.png'
              };
            }
          });
          
          const processedImages = await Promise.all(imagePromises);
          
          // メイン画像URLの配列として設定
          const imageUrls = processedImages.map(img => img.mainImageUrl);
          setImages(imageUrls);
          setImageData(processedImages); // 詳細データも保存
          setImageLength(processedImages.length);
          

          // 最初の画像を選択
          if (processedImages.length > 0) {
            setCurrentImageIndex(0);
            // 1枚目の画像のタグのみを読み込み（初期表示の高速化）
            const firstImage = processedImages[0];
            if (firstImage.objectId !== null && firstImage.objectImageId !== null 
              && firstImage.objectImageId !== undefined && firstImage.objectImageId !== '' ) {
              loadImageTags(firstImage.objectId, firstImage.objectImageId, 0);
            }
          }

          if (!pollingInterval && !pollingIntervalRef.current && !duringPolling) {
            if (uploadedCount === objectImages.length && noUploadedCount === 0) {
              // 全ての画像がアップロード済み
              setOdIsUploaded(1);
              setDuringPolling(false);
            } else {
              // アップロード未完了の画像がある場合はpolling開始
              setOdIsUploaded(0);
              
              // polling開始
              startPolling(objectImages.length);
            }
          }
        } else {
          // 画像がない場合
          setImages([]);
          setImageData([]);
          setImageLength(0);
          setOdIsUploaded(1);
        }
        
      } else {
        // 画像がない場合
        setImages([]);
        setImageData([]);
        setImageLength(0);
        setOdIsUploaded(1);
      }
    } catch (error) {
      handleApiError(new Error('画像の取得に失敗しました。'));
    }
  };

  /**
   * 全てのポーリングプロセスを停止
   * 画像アップロード状況の監視を停止し、関連する状態をリセット
   */
  const stopAllPollingProcesses = () => {
    setDuringPolling(false);
    setPollingInterval(null);

    if (pollingIntervalRef.current) {
      clearTimeout(pollingIntervalRef.current);
      pollingIntervalRef.current = null;
    }

    if (window.currentPollingInterval) {
      clearTimeout(window.currentPollingInterval);
      window.currentPollingInterval = null;
    }
  };


  /**
   * ポーリング機能の実装
   * 画像アップロード状況を定期的にチェックし、完了時に自動更新
   * useRefのみで制御（useStateの非同期更新によるレースコンディションを回避）
   * @param {number} imageLength - 画像総数
   */
  const startPolling = (imageLength) => {
    // 重複実行を防ぐチェック（useRefのみで同期的に判定）
    if (pollingIntervalRef.current) {
      return;
    }

    const maxPollingCount = imageLength + 3;
    let currentPollingCount = 0;
    let isPollingActive = true; // ローカル変数で実行中を追跡（クロージャ内で確実に参照可能）

    setDuringPolling(true);
    setOdIsUploaded(0);

    const pollOnce = async () => {
      if (!isPollingActive) return;
      currentPollingCount++;

      const folderId = hozonFolder || '99';
      try {
        const latestImageData = await mobileObjectDetailService.getObjectImageList(objectId, folderId);

        if (!isPollingActive) return; // 非同期完了後に再チェック

        if (latestImageData && latestImageData.objectDatas && latestImageData.objectDatas.length > 0) {
          const objectImages = latestImageData.objectDatas[0].objectImages;

          if (objectImages && objectImages.length > 0) {
            let uploadedCount = 0;
            let noUploadedCount = 0;

            for (let i = 0; i < objectImages.length; i++) {
              const image = objectImages[i];
              if (image.isUploaded === 0) {
                noUploadedCount++;
              } else {
                uploadedCount++;
                const idx = i;
                // アップロード完了した画像をBlob取得して差し替え
                setImageData(prev => {
                  if (prev[idx] && prev[idx].mainImageUrl === '/core/img/sendingimage.png') {
                    mobileObjectDetailService.getImageAsBlob(
                      image.objectId,
                      image.objectImageId,
                      image.objectImageEditId,
                      image.filenameExtension,
                      image.isUploaded
                    ).then(blobUrl => {
                      setImageData(prevData => {
                        const updated = [...prevData];
                        if (updated[idx]) {
                          // 古いBlob URLを解放
                          if (updated[idx].mainImageUrl && updated[idx].mainImageUrl.startsWith('blob:')) {
                            URL.revokeObjectURL(updated[idx].mainImageUrl);
                          }
                          updated[idx] = { ...updated[idx], mainImageUrl: blobUrl, thumbnailUrl: blobUrl };
                        }
                        return updated;
                      });
                      setImages(prevImages => {
                        const updated = [...prevImages];
                        if (updated[idx] && updated[idx].startsWith('blob:')) {
                          URL.revokeObjectURL(updated[idx]);
                        }
                        updated[idx] = blobUrl;
                        return updated;
                      });
                    }).catch(() => {});
                  }
                  return prev;
                });
              }
            }

            // 全画像アップロード完了
            if (uploadedCount === objectImages.length && noUploadedCount === 0) {
              stopPolling(1);
              return;
            }

            // 最大試行回数に達した
            if (currentPollingCount >= maxPollingCount) {
              stopPolling(0);
              return;
            }
          }
        }
      } catch (error) {
        stopPolling(0);
        return;
      }

      // 次のポーリングをスケジュール（setIntervalではなくsetTimeoutチェーンで重複防止）
      if (isPollingActive) {
        pollingIntervalRef.current = setTimeout(pollOnce, 5000);
      }
    };

    const stopPolling = (reason) => {
      isPollingActive = false;
      if (pollingIntervalRef.current) {
        clearTimeout(pollingIntervalRef.current);
        pollingIntervalRef.current = null;
      }
      setDuringPolling(false);
      setPollingInterval(null);
      if (window.currentPollingInterval) {
        clearTimeout(window.currentPollingInterval);
        window.currentPollingInterval = null;
      }
      setOdIsUploaded(reason === 1 ? 1 : 0);
    };

    // 初回を5秒後に開始（アップロード開始の猶予）
    pollingIntervalRef.current = setTimeout(pollOnce, 5000);
    window.currentPollingInterval = pollingIntervalRef.current;
  };

  /**
   * 動画データの読み込み
   * オブジェクトに紐づく動画一覧を取得し、表示用URLを生成
   */
  const loadMovie = async () => {
    try {
      // 動画一覧を取得
      const movieData = await mobileObjectDetailService.getMovieList(objectId);

      if(movieData.returnCode !== '200'){
        MessageDialog.show('エラー', '動画の取得に失敗しました。', null, 'error');
        return;
      }
      
      if (movieData && movieData.movieList && movieData.movieList.length > 0) {
        const movieList = movieData.movieList;
        
        // 動画データを処理してstateに設定
        const processedMovies = movieList.map((movie, index) => ({
          ...movie,
          movieIndex: index,
          videoUrl: `/pix/movie.action?objectId=${movie.objectId}&objectMovieId=${movie.objectMovieId}&filenameExtension=${movie.filenameExtension}`,
          videoId: `v_${movie.objectId}_${movie.objectMovieId}`,
          thumbnailUrl: `/pix/movie.action?objectId=${movie.objectId}&objectMovieId=${movie.objectMovieId}&filenameExtension=${movie.filenameExtension}&thumbnail=true`,
          satsueiKanryoJikoku: movie.satsueiKanryoJikoku || '',
          latitude: movie.latitude || '',
          longitude: movie.longitude || ''
        }));
        
        setMovies(processedMovies);
        setMovieData(processedMovies); // 動画詳細データも設定
        
        // 最初の動画を選択
        if (processedMovies.length > 0) {
          setCurrentMovieIndex(0);
          handleMovieSelect(0);
        }
        
      } else {
        // 動画がない場合
        setMovies([]);
        setMovieData([]);
      }
      
    } catch (error) {
      handleApiError(new Error('動画の取得に失敗しました。'));
    }
  };

  // 動画選択時の処理
  const handleMovieSelect = (movieIndex) => {
    if (movies && movies[movieIndex]) {
      const selectedMovie = movies[movieIndex];
      setCurrentMovieIndex(movieIndex);
      setMovieUrl(selectedMovie.videoUrl);
    }
  };

  // 保存フォルダ変更時の処理
  const handleHozonFolderChange = async (e) => {
    try {
      const selectedFolderId = parseInt(e.target.value, 10);
      setHozonFolder(selectedFolderId);
      
      // 画像を再読み込み
      await loadImage(selectedFolderId);
    } catch (error) {
      handleApiError(new Error('フォルダ変更処理に失敗しました。'));
    }
  };

  // 画像選択時の処理
  const handleImageSelect = (imageIndex) => {
    if (imageData && imageData[imageIndex]) {
      const selectedImage = imageData[imageIndex];
      
      // 既に同じ画像が選択されている場合は処理をスキップ
      if (currentImageIndex === imageIndex) {
        return;
      }
      
      // 現在の画像インデックスを設定
      setCurrentImageIndex(imageIndex);
      
      // 画像タグの取得と表示
      if (selectedImage.objectId !== null && selectedImage.objectImageId !== null 
        && selectedImage.objectImageId !== undefined && selectedImage.objectImageId !== '' ) {
        loadImageTags(selectedImage.objectId, selectedImage.objectImageId, imageIndex);
      }
    }
  };

  // 画像タグの読み込み
  const loadImageTags = async (objectId, objectImageId, imageIndex = null) => {

    const targetIndex = imageIndex !== null ? imageIndex : currentImageIndex;
    try {
      const tagData = await mobileObjectDetailService.getObjectImageTag(objectId, objectImageId);

      if(tagData.returnCode !== '200'){
        // エラーの場合は空配列を設定
        setImageTags(prev => ({
          ...prev,
          [targetIndex]: []
        }));
        return;
      }
      
      // レスポンスからimageTagListを取得し、imageTagId順にソートしてimageTagプロパティの配列に変換
      if (tagData.imageTagList && tagData.imageTagList.length > 0) {
        const sortedTags = tagData.imageTagList
          .sort((a, b) => a.imageTagId - b.imageTagId)
          .map(tag => tag.imageTag);
        
        
        // 指定された画像のタグを更新
        setImageTags(prev => {
          const newTags = {
            ...prev,
            [targetIndex]: sortedTags
          };
          return newTags;
        });
      } else {
        // タグがない場合は空配列を設定
        setImageTags(prev => ({
          ...prev,
          [targetIndex]: []
        }));
      }
    } catch (error) {
      // エラーの場合は空配列を設定
      setImageTags(prev => ({
        ...prev,
        [targetIndex]: []
      }));
    }
  };

  // 一覧表示への遷移処理
  const handleShowList = () => {
    // 全てのpollingプロセスを確実に停止
    stopAllPollingProcesses();
            
    // 状態をリセット
    setOdIsUploaded(1);
    
    // 表示内容をクリア
    clearDisplayData();
    
    // onCloseが指定されている場合はそれを使用、そうでなければ従来の遷移処理
    if (onClose) {
      onClose();
    } else {      
      if (resolvedFromPage) {
        // 遷移元ページが指定されている場合
        switch (resolvedFromPage) {
          case 'satsuei':
            navigate('/appSatsuei');
            break;
          case 'search':
            navigate('/appSearch?from=search');
            break;
          case 'top':
            navigate('/appTop');
            break;
          default:
            navigate('/appSearch?objectId=' + objectId);
        }
      } else {
        // デフォルトは検索画面
        navigate('/appSearch?objectId=' + objectId);
      }
    }
  };

  // フッターからの遷移処理
  const handleFooterNavigation = useCallback(async (path) => {

    // フォームに変更がある場合は確認ダイアログを表示
    if (formChangeFlg) {
      let confirmed = false
      await MessageDialog.showConfirm('確認', '値が変更されています。このページから移動しますか？', () => { confirmed = true })
      if (!confirmed) return
    }

    // 全てのpollingプロセスを確実に停止
    stopAllPollingProcesses();

    clearDisplayData();
    
    // 遷移元に応じて適切な動作を決定
    if (path === '/appTop' && resolvedFromPage === 'top') {
      // AppTopから遷移した場合、ホームボタンは戻るボタンと同じ動作
      if (onClose) {
        onClose();
      }
      // ホーム画面に遷移
      navigate('/appTop');
    } else if (path === '/appSearch' && resolvedFromPage === 'search') {
      // AppSearchから遷移した場合、検索ボタンは戻るボタンと同じ動作
      if (onClose) {
        onClose();
      }
      // 検索画面に遷移
      navigate('/appSearch');
    } else if (path === '/appSatsuei' && resolvedFromPage === 'satsuei') {
      // AppSatsueiから遷移した場合、撮影ボタンは戻るボタンと同じ動作
      if (onClose) {
        onClose();
      }
      // 撮影画面に遷移
      navigate('/appSatsuei');
    } else {
      // その他の場合は通常の遷移処理
      if (onClose) {
        onClose();
      }
      if (path) {
        navigate(path);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [resolvedFromPage, onClose, navigate, formChangeFlg]);

  // 表示内容のクリア
  const clearDisplayData = useCallback(() => {

    // 基本状態をリセット
    setSelectFlg(0);
    setImageLength(0);
    setOdIsUploaded(1);
    setIsLoading(false);
    setHasObjectData(false);
    setShowImageEdit(false);
    setShowCopyModal(false);
    setShowImageTagListModal(false);
    setShowImageReshootModal(false);
    setShowImageCaptureFromPositionModal(false);
    setShowImageDeleteModal(false);
    setShowImageSwapModal(false);
    setShowImageHandwriteEditModal(false);
    setShowMovieReshootModal(false);
    setShowMovieDeleteModal(false);
    setCopyDestinationObjectId('');
    
    // フォームデータをリセット
    setSatsueiMemoCategory('');
    setSatsueiGuide('');
    setKyoten('');
    setHozonFolder(0);
    
    // 画像・動画データをリセット
    setImages([]);
    setImageData([]);
    setCurrentImageIndex(0);
    setMovies([]);
    setMovieData([]);
    setCurrentMovieIndex(0);
    setMovieUrl('');
    setImageTags({});
    
    
    // ドロップダウンオプションをリセット
    setSatsueiMemoCategories([]);
    setSatsueiGuides([]);
    setKyotenLists([]);
    setHozonFolders([]);
    setFolderImageCounts({});
    setTotalImageCount(0);
  }, []);

  // フッターコンポーネントのメモ化
  const memoizedFooter = useMemo(() => {
    return <Footer onFooterClick={handleFooterNavigation} data-testid="footer" />;
  }, [handleFooterNavigation]);

  // 画像モードへの切り替え
  const handleSwitchImage = () => {
    setSelectFlg(0);
  };

  // 動画モードへの切り替え
  const handleSwitchMovie = () => {
    setSelectFlg(1);
    // 動画データが読み込まれていない場合は読み込む
    if (movies.length === 0) {
      loadMovie();
    } else {
      // 既に動画データがある場合は、最初の動画を選択してmovieUrlを設定
      handleMovieSelect(0);
    }
  };

  // シェア処理
  const handleImageShare = async () => {
    try {
      setIsLoading(true);
      const response = await mobileObjectDetailService.addObjectShare(objectId);
      
      // ビジネスロジックエラーのチェック（returnCode !== '200'の場合）
      if (response.returnCode !== '200') {
        MessageDialog.show('エラー', 'シェア処理中にエラーが発生しました。', null, 'error');
        setIsLoading(false); // ローディングを停止
        return;
      }
      
      setShareData(response);
      setShowShareModal(true);
    } catch (error) {
      handleApiError(new Error('シェア処理に失敗しました。'));
    } finally {
      setIsLoading(false);
    }
  };

  // シェアモーダルの閉じる処理
  const handleShareModalClose = () => {
    setShowShareModal(false);
    setShareData(null);
  };

  // 画像撮影開始処理
  const handleSatsueiStart = async () => {
    try {
      setIsLoading(true);
      
      // カメラ起動用データを準備
      const cameraData = await mobileSatsueiService.prepareCameraData({
        objectId: objectId,
        satsueiMemoCategoryId: satsueiMemoCategory,
        userKyotenId: userKyotenId || '0',
        imageFolderId: hozonFolder || 99,
        satsueiGuideId: satsueiGuide || '',
        backUrl: '/appObjectDetail?objectId=' + objectId + '&objectIdAutoFlg=' + objectIdAutoFlg + '&from=search',
        isSaveLocal: isSaveLocal || '0',
        target: 'new',
        startImageOrderIndex: 0,
        thetaCameraUsage: thetaCameraUsage
      });

      // ネイティブアプリのカメラを起動
      mobileSatsueiService.startUpCamera(cameraData);

    } catch (error) {
      handleApiError(new Error('カメラ起動に失敗しました。'));
    } finally {
      setIsLoading(false);
    }
  };

  // 動画撮影開始処理
  const handleMovieSatsueiStart = async () => {
    try {
      setIsLoading(true);

      // カメラ起動用データを準備
      const cameraData = await mobileSatsueiService.prepareCameraData({
        objectId: objectId,
        satsueiMemoCategoryId: satsueiMemoCategory,
        userKyotenId: userKyotenId || '0',
        imageFolderId: hozonFolder || 0,
        satsueiGuideId: satsueiGuide || '',
        backUrl: '/appObjectDetail?objectId=' + objectId + '&objectIdAutoFlg=' + objectIdAutoFlg + '&from=search',
        isSaveLocal: isSaveLocal || '',
        target: 'new',
        startMovieOrderIndex: 0
      });

      // ネイティブアプリのカメラを起動
      mobileSatsueiService.startUpCamera(cameraData);
      console.log('📷cameraData', cameraData);
      
    } catch (error) {
      handleApiError(new Error('カメラ起動に失敗しました。'));
    } finally {
      setIsLoading(false);
    }
  };

  // 画像編集モーダルを開く
  const handleOpenImageEdit = () => {
    setShowImageEdit(true);
  };

  // 画像編集モーダルを閉じる
  const handleCloseImageEdit = () => {
    setShowImageEdit(false);
  };

  /**
   * 撮影メモ登録処理
   * フォームデータをJavaのgetSpRegistScriptメソッドと同様の形式に変換してAPIに送信
   */
  const handleRegistMemo = async () => {
    try {
      setIsLoading(true);
      
      // JavaのgetSpRegistScriptメソッドと同様のデータ構造を作成
      const formData = {
        objectId,
        satsueiMemoCategoryId: satsueiMemoCategory,
        kyotenId: kyoten,
        satsueiGuideId: satsueiGuide,
        registSatsueiMemoColumnList: []
      };

      // 各カラムのデータを構築（Javaの実装と同様）
      satsueiMemoColumns.forEach((column) => {
        const columnData = {
          satsueiMemoCategoryId: column.satsueiMemoCategoryId,
          satsueiMemoColumnName: column.satsueiMemoColumnName,
          satsueiMemoColumnId: column.satsueiMemoColumnId,
          columnType: column.columnType,
          requiredFlg: column.requiredFlg,
          key: column.key,
          satsueiMemoColumnValueList: []
        };

        switch (column.columnType) {
          case 1: // ラベル
          case 2: // 文字列(1行)
          case 3: // 文字列(複数行)
          case 4: // 数値
          case 17: // 小数点数値
            // 直接値を設定（Javaの$('#id').val()と同等）
            columnData.value = satsueiMemoFormData[column.key] || '';
            break;

          case 9: { // 日付
            // 日付を「yyyy/MM/dd」形式に変換
            const dateValue = satsueiMemoFormData[column.key];
            if (dateValue) {
              const date = new Date(dateValue);
              if (!isNaN(date.getTime())) {
                const year = date.getFullYear();
                const month = String(date.getMonth() + 1).padStart(2, '0');
                const day = String(date.getDate()).padStart(2, '0');
                columnData.value = `${year}/${month}/${day}`;
              } else {
                columnData.value = dateValue;
              }
            } else {
              columnData.value = '';
            }
            break;
          }

          case 10: { // 日時
            // 日時を「yyyy/MM/dd HH:mm」形式に変換
            const datetimeValue = satsueiMemoFormData[column.key];
            if (datetimeValue) {
              const date = new Date(datetimeValue);
              if (!isNaN(date.getTime())) {
                const year = date.getFullYear();
                const month = String(date.getMonth() + 1).padStart(2, '0');
                const day = String(date.getDate()).padStart(2, '0');
                const hours = String(date.getHours()).padStart(2, '0');
                const minutes = String(date.getMinutes()).padStart(2, '0');
                columnData.value = `${year}/${month}/${day} ${hours}:${minutes}`;
              } else {
                columnData.value = datetimeValue;
              }
            } else {
              columnData.value = '';
            }
            break;
          }

          case 5: // ラジオボタン
          case 6: // チェックボックス
          case 7: // 複数選択
          case 8: // プルダウン
          case 11: // 2段階選択
          case 12: // 3段階選択
          case 13: // 5段階選択
          case 14: // 10段階選択
            // 選択値の配列を設定
            // columnData.satsueiMemoColumnValueList = [];
            
            column.satsueiMemoColumnValueList?.forEach((columnValue) => {
              const valueData = {
                key: columnValue.key,
                satsueiMemoColumnValueId: columnValue.satsueiMemoColumnValueId
              };

              switch (column.columnType) {
                case 5: // ラジオボタン
                case 6: // チェックボックス
                case 11: // 2段階選択
                case 12: // 3段階選択
                case 13: // 5段階選択
                case 14: // 10段階選択
                  // Javaの$('#id').prop('checked')と同等
                  valueData.value = satsueiMemoFormData[column.key]?.[columnValue.key] === '1' ? 'true' : 'false';
                  break;

                case 7: // 複数選択
                  if (columnValue.deleteFlg === 1) {
                    // 削除された項目はhiddenで持たせる（Javaの実装と同様）
                    valueData.value = satsueiMemoFormData[column.key]?.[columnValue.key] === '1' ? 'true' : 'false';
                  } else {
                    // Javaの$('#id').prop('selected')と同等
                    valueData.value = satsueiMemoFormData[column.key]?.[columnValue.key] === '1' ? 'true' : 'false';
                  }
                  break;

                case 8: // プルダウン
                  // Javaの$('#id').prop('selected')と同等
                  valueData.value = satsueiMemoFormData[column.key]?.[columnValue.key] === '1' ? 'true' : 'false';
                  break;
              }

              columnData.satsueiMemoColumnValueList.push(valueData);
            });
            break;
        }

        formData.registSatsueiMemoColumnList.push(columnData);  
      });

      let result;
      if(hasObjectData){
        // 更新
        result = await mobileObjectDetailService.updateObject(formData);
      } else {
        // 新規登録
        result = await mobileObjectDetailService.addObject(formData);
      }
      
      // ビジネスロジックエラーのチェック（returnCode !== '200'の場合）
      if (result.returnCode !== '200') {
        MessageDialog.show('エラー', '登録処理に失敗しました。', null, 'error');
        setIsLoading(false); // ローディングを停止
        return;
      }
      
      setFormChangeFlg(false); // 登録完了時にフラグをリセット
      MessageDialog.show('メッセージ', '登録が完了しました。');
      
      // フォームデータの初期化
      if (satsueiMemoFormRef.current) {
        satsueiMemoFormRef.current.initializeFormData();
      }
      
      // 登録完了後にページを再読み込み（ローディングは継続）
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    } catch (error) {
      handleApiError(new Error('登録処理に失敗しました。'));
      setIsLoading(false); // エラー時のみローディングを停止
    }
  };

  // オブジェクトコピー処理
  const handleCopyObject = async () => {
    try {
      if (objectIdAutoFlg === '1') {
        // Load next object ID
        const id = await mobileObjectDetailService.getMaxCopyObjectId();

        if(id.returnCode !== '200'){
          MessageDialog.show('エラー', 'IDの取得に失敗しました。', null, 'error');
          return;
        }

        setCopyDestinationObjectId(id);
        setCopyInputDisabled(true);
        setShowCopyModal(true);
      } else {
        setCopyDestinationObjectId('');
        setCopyInputDisabled(false);
        setShowCopyModal(true);
      }
    } catch (error) {
      handleApiError(new Error('IDの取得に失敗しました。'));
    }
  };

  // コピー確認処理
  const handleCopyConfirm = async () => {
    try {
      setIsLoading(true);
      
      // IDの入力チェック
      if (!copyDestinationObjectId.trim()) {
        MessageDialog.show('メッセージ', 'IDを入力してください。');
        return;
      }

      // 既存IDの存在チェック
      try {
        const objectCount = await mobileObjectDetailService.getObjectCount(copyDestinationObjectId);

        if(objectCount.returnCode !== '200'){
          MessageDialog.show('エラー', 'IDの存在確認に失敗しました。', null, 'error');
          return;
        }

        if (objectCount.objectCount === 1) {
          MessageDialog.show('メッセージ', '登録済みのIDにはコピーできません。');
          setCopyDestinationObjectId('');
          return;
        }
      } catch (error) {
        handleApiError(new Error('IDの存在確認に失敗しました。'));
        return;
      }

      // 確認ダイアログの表示
      const confirmed = await new Promise((resolve) => {
        MessageDialog.showConfirm(
          '確認',
          'コピーしてもよろしいですか？',
          () => resolve(true),
          () => resolve(false)
        );
      });

      if (!confirmed) {
        return;
      }

      // ボタンの無効化とテキスト変更
      setCopyButtonDisabled(true);
      setCopyButtonText('コピー中...');

      // コピー処理の実行
      const result = await mobileObjectDetailService.copyObject(objectId, copyDestinationObjectId, satsueiMemoCategory);
      
      // ビジネスロジックエラーのチェック（returnCode !== '200'の場合）
      if (result.returnCode !== '200') {
        MessageDialog.show('エラー', 'コピー処理中にエラーが発生しました。', null, 'error');
        // ボタンの状態をリセット
        setCopyButtonDisabled(false);
        setCopyButtonText('コピー');
        return;
      }
      
      if (result.message) {
        // 別途IDの登録が行われた場合
        MessageDialog.show(
          '確認',
          `別途ID「${result.copyDestinationObjectId}」の登録が行われたため、コピーに失敗しました。\nお手数ですが、別のIDを指定してください。`,
          () => {
            setShowCopyModal(false);
          }
        );
      } else {
        // コピー成功
        MessageDialog.show(
          'メッセージ',
          `コピーが完了しました。\n「${result.copyDestinationObjectId}」を表示します。`,
          () => {
            setShowCopyModal(false);
            // コピー先に遷移
            navigate(`/appObjectDetail?objectId=${result.copyDestinationObjectId}&objectIdAutoFlg=${objectIdAutoFlg}&from=${resolvedFromPage}`);
            // 画面をリロード
            window.location.reload();
          }
        );
      }
    } catch (error) {
      handleApiError(new Error('コピー処理に失敗しました。'));
    } finally {
      setIsLoading(false);
      // ボタンの状態をリセット
      setCopyButtonDisabled(false);
      setCopyButtonText('コピー');
    }
  };

  // オブジェクト削除処理
  const handleDelete = async () => {
    await MessageDialog.showConfirm('確認', 'このオブジェクトを削除してもよろしいですか？', async () => {
      try {
        setIsLoading(true);
        const result = await mobileObjectDetailService.deleteObject(objectId);
        setIsLoading(false);

        if (result.returnCode !== '200') {
          MessageDialog.show('エラー', '削除処理中にエラーが発生しました。', null, 'error');
          return;
        }

        MessageDialog.show('メッセージ', '削除が完了しました。');
        handleShowList();
      } catch (error) {
        setIsLoading(false);
        handleApiError(new Error('削除処理に失敗しました。'));
      }
    });
  };

  // サムネイルクリック処理
  const handleThumbnailClick = (index) => {
    handleImageSelect(index);
  };

  // 動画サムネイルクリック処理
  const handleMovieThumbnailClick = (index) => {
    setCurrentMovieIndex(index);
    handleMovieSelect(index);
  };

  // 画像編集アクション処理
  const handleImageEditAction = (actionId) => {
    switch (actionId) {
      case '0': // 画像タグ設定
        setShowImageTagListModal(true);
        break;
      case '1': // 画像再撮影
        setShowImageReshootModal(true);
        break;
      case '2': // 指定位置から撮影開始
        setShowImageCaptureFromPositionModal(true);
        break;
      case '3': // 画像削除
        setShowImageDeleteModal(true);
        break;
      case '4': // 画像入れ替え
        setShowImageSwapModal(true);
        break;
      case '5': // 画像手書き編集
        setShowImageHandwriteEditModal(true);
        break;
      default:
        break;
    }
    setShowImageEdit(false);
  };

  // 画像再撮影後のコールバック
  const handleImageReshoot = () => {
    // 必要に応じて追加の処理を実装
  };

  // 指定位置から撮影開始後のコールバック
  const handleCaptureFromPosition = () => {
    // 必要に応じて追加の処理を実装
  };

  // 画像削除後のコールバック
  const handleImageDeleted = async () => {
    await loadImage();
  };

  // 動画再撮影後のコールバック
  const handleMovieReshoot = () => {
    // 必要に応じて追加の処理を実装
  };

  // 動画削除後のコールバック
  const handleMovieDeleted = async () => {
    await loadMovie(true);
  };

  // 画像入れ替え後のコールバック
  const handleImageSwapped = async () => {
    // 画像を再読み込みして表示を更新
    await loadImage();
  };

  // 画像手書き編集完了後のコールバック
  const handleHandwriteEditComplete = async () => {
    // 画像を再読み込みして表示を更新
    await loadImage();
  };

  // タグ更新後のコールバック
  const handleTagsUpdated = async (imageIndex, newTags, isFullUpdate = false) => {
    if (isFullUpdate) {
      // 全体更新の場合は画像を再読み込み
      await loadImage();
      
      // 1枚目の画像タグのみを読み込み（初期表示の高速化）
      if (imageData && imageData.length > 0) {
        const firstImage = imageData[0];
        if (firstImage.objectId !== null && firstImage.objectImageId !== null 
          && firstImage.objectImageId !== undefined && firstImage.objectImageId !== '' ) {
          await loadImageTags(firstImage.objectId, firstImage.objectImageId, 0);
        }
      }
      return;
    }
    
    if (imageIndex !== null && newTags !== null) {
      // 個別画像のタグ更新
      setImageTags(prev => ({
        ...prev,
        [imageIndex]: newTags
      }));
    }
    
    // タグ更新後、現在表示中の画像のタグを再読み込み
    if (imageData && imageData[currentImageIndex]) {
      const currentImage = imageData[currentImageIndex];
      if (currentImage.objectId !== null && currentImage.objectImageId !== null 
        && currentImage.objectImageId !== undefined && currentImage.objectImageId !== '' ) {
        await loadImageTags(currentImage.objectId, currentImage.objectImageId, currentImageIndex);
      }
    }
  };

  // 動画編集アクション処理
  const handleMovieEditAction = (actionId) => {
    switch (actionId) {
      case '0': // 動画再撮影
        setShowMovieReshootModal(true);
        break;
      case '1': // 動画削除
        setShowMovieDeleteModal(true);
        break;
      default:
        break;
    }
    setShowImageEdit(false);
  };


  // レンダリング関数群
  const renderImageArea = () => {
    return (
      <div style={styles.imageArea}>
        {images.length !== 0 ? (
          <div style={styles.imageMainAreaTop}>
            <div style={styles.satsueiKanryoJikoku}>
              {imageData[currentImageIndex]?.satsueiKanryoJikoku || ''}
            </div>
            <div style={styles.satsueiMaisu}>
             {currentImageIndex + 1}枚目 / 全{imageLength}枚
             {odIsUploaded === 0 && (
               <span style={{color: '#FFA500', marginLeft: '10px'}}>
                 (アップロード中...)
               </span>
             )}
            </div>
          </div>
        ) : null}
      
      {images.length === 0 ? (
        <div style={styles.imageMainAreaMisatsuei}>
          <div style={styles.misatsuei}>
            <div style={styles.message}>まだ写真を撮影していません</div>
            <button style={styles.satsueiStart} onClick={handleSatsueiStart} data-testid="image-shoot-button">
              撮影を開始
            </button>
          </div>
        </div>
      ) : (
        <div style={styles.imageMainArea}>
          <img 
            src={images[currentImageIndex]} 
            alt="メイン画像"
            style={styles.imageMain}
            onError={(e) => {
              e.target.src = '/core/img/errorimage.png';
            }}
            data-testid='image-main'
          />
        </div>
      )}
      
      {(() => {
        const currentTags = imageTags[currentImageIndex];
        return currentTags && currentTags.length > 0 ? (
          <div style={styles.imageTagArea}>
            <div style={styles.imageTag}>
              {currentTags.map((tag, index) => (
                <span key={index} style={styles.tagItem}>
                  {tag}
                </span>
              ))}
            </div>
          </div>
        ) : null;
      })()}

      {images.length > 0 && (
      <div style={styles.imageMainAreaBottom}>
        <div style={styles.satsueiBasho}>
          {imageData[currentImageIndex]?.latitude}-{imageData[currentImageIndex]?.longitude}
        </div>
      </div>
      )}

      {images.length > 1 && (
        <div style={styles.imageThumbnailArea}>
          <ul style={styles.imageThumbnail}>
            {imageData.map((image, index) => (
              <li 
                key={index}
                style={{
                  ...styles.thumbnailItem,
                  borderColor: index === currentImageIndex ? '#F93535' : '#ddd'
                }}
                onClick={() => handleThumbnailClick(index)}
              >
                <img 
                  src={image.thumbnailUrl || image.mainImageUrl} 
                  alt={`サムネイル ${index + 1}`}
                  style={styles.thumbnailImage}
                  onError={(e) => {
                    e.target.src = '/core/img/errorimage.png';
                  }}
                />
              </li>
            ))}
          </ul>
        </div>
      )}
      </div>
    );
  };

  // 動画エリアのレンダリング
  const renderMovieArea = () => {
    return (
      <div style={styles.movieArea}>
        {movies.length === 0 ? (
          <div style={styles.movieMainAreaMisatsuei}>
            <div style={styles.misatsuei}>
              <div style={styles.message}>まだ動画を撮影していません</div>
                <button style={styles.movieSatsueiStart} onClick={handleMovieSatsueiStart} data-testid="movie-shoot-button">
                  撮影を開始
                </button>
            </div>
          </div>
        ) : (
          <>
            <div style={styles.movieMainArea}>
              <video 
                src={movies[currentMovieIndex]?.videoUrl || ''} 
                controls
                style={styles.movieMain}
                data-testid="movie-main"
              />
            </div>
            
            {movies.length > 1 && (
              <div style={styles.movieThumbnailArea}>
                <ul style={styles.movieThumbnail}>
                  {movies.map((movie, index) => (
                    <li 
                      key={index}
                      style={{
                        ...styles.movieThumbnailItem,
                        borderColor: index === currentMovieIndex ? '#F93535' : '#ddd'
                      }}
                      onClick={() => handleMovieThumbnailClick(index)}
                    >
                      <img 
                        src={movie.thumbnailUrl || '/core/img/movie-placeholder.png'} 
                        alt={`動画サムネイル ${index + 1}`}
                        style={styles.movieThumbnailImage}
                        onError={(e) => {
                          e.target.src = '/core/img/errorimage.png';
                        }}
                      />
                      <div style={styles.moviePlayIcon}></div>
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </>
        )}
      </div>
    );
  };

  // 画像編集モーダルのレンダリング
  const renderImageEditModal = () => (
    <div style={{...styles.imageEditArea, display: showImageEdit ? 'flex' : 'none'}}>
      <div style={styles.imageEditContent}>
        <button style={styles.closeImageEdit} onClick={handleCloseImageEdit}>
          戻る
        </button>
        
        {selectFlg === 0 && (
          <div>
            <button 
              style={styles.imageEditButton}
              onClick={() => handleImageEditAction('0')}
            >
              画像タグ設定
            </button>
            <button 
              style={styles.imageEditButton}
              onClick={() => handleImageEditAction('1')}
            >
              画像再撮影
            </button>
            <button 
              style={styles.imageEditButton}
              onClick={() => handleImageEditAction('2')}
            >
              指定位置から撮影開始
            </button>
            <button 
              style={styles.imageEditButton}
              onClick={() => handleImageEditAction('3')}
            >
              画像削除
            </button>
            <button 
              style={styles.imageEditButton}
              onClick={() => handleImageEditAction('4')}
            >
              画像入れ替え
            </button>
            <button 
              style={styles.imageEditButton}
              onClick={() => handleImageEditAction('5')}
            >
              画像手書き編集
            </button>
          </div>
        )}
        
        {selectFlg === 1 && (
          <div>
            <button 
              style={styles.imageEditButton}
              onClick={() => handleMovieEditAction('0')}
            >
              動画再撮影
            </button>
            <button 
              style={styles.imageEditButton}
              onClick={() => handleMovieEditAction('1')}
            >
              動画削除
            </button>
          </div>
        )}
      </div>
    </div>
  );

  // コピーモーダルのレンダリング
  const renderCopyModal = () => (
    <div style={{...styles.modal, display: showCopyModal ? 'flex' : 'none'}} data-testid="copy-modal">
      <div style={styles.modalContent}>
        <div style={{marginBottom: '20px', textAlign: 'center'}}>
          コピー先のIDを<br />指定してください
        </div>
        <input
          id="copyDestinationObjectId"
          name="copyDestinationObjectId"
          type="text"
          value={copyDestinationObjectId}
          onChange={(e) => setCopyDestinationObjectId(e.target.value)}
          placeholder="ID"
          disabled={copyInputDisabled}
          style={{
            ...styles.modalInput,
            backgroundColor: copyInputDisabled ? '#DCDCDC' : styles.modalInput.backgroundColor
          }}
        />
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '10px' }}>
          <button 
            style={{
              ...styles.modalButton,
              background: copyButtonDisabled ? '#a29d9de0' : styles.modalButton.background,
              border: copyButtonDisabled ? 'solid 0.5px black' : styles.modalButton.border
            }} 
            onClick={handleCopyConfirm}
            disabled={copyButtonDisabled}
            data-testid="copy-confirm-button"
          >
            {copyButtonText}
          </button>
          <button 
            style={{
              ...styles.modalCancelButton,
              background: copyButtonDisabled ? '#a29d9de0' : styles.modalCancelButton.background,
              border: copyButtonDisabled ? 'solid 0.5px black' : styles.modalCancelButton.border
            }} 
            onClick={() => {
              setShowCopyModal(false);
              setCopyInputDisabled(false);
            }}
            disabled={copyButtonDisabled}
          >
            キャンセル
          </button>
        </div>
      </div>
    </div>
  );


  return (
    <div style={styles.container}>
      {/* ローディング中の場合はローディング画面を表示 */}
      {isLoading ? (
        <div style={styles.loading}>
          <div>読み込み中...</div>
        </div>
      ) : (
        <>
        {/* Header */}
        <div style={styles.detailHeader}>
          <div style={styles.headerLeft}>
            <div style={styles.showList} onClick={handleShowList} data-testid="back-button"></div>
            <div style={styles.objectIdArea}>
              <div style={styles.objectIdAreaTitle}>ID</div>
              <div style={styles.objectIdAreaBody} data-testid="object-id">{objectId}</div>
            </div>
          </div>
        </div>
  
        {/* Image/Movie Switch Header */}
        <div style={styles.imageMainAreaHeader}>
          <div style={{ overflow: 'hidden' }}>
            <div style={styles.headerLeft}>
              <div 
                style={{
                  ...styles.switchImageButtonArea,
                  backgroundColor: selectFlg === 0 ? '#f93535' : '#EEE',
                  backgroundSize: 'contain'
                }}
                onClick={handleSwitchImage}
                data-testid="switch-image-button"
              >
                <div style={styles.switchImageButton}></div>
              </div>
              <div
                style={{
                  ...styles.switchMovieButtonArea,
                  backgroundColor: selectFlg === 1 ? '#f93535' : '#EEE',
                  backgroundSize: 'contain'
                }}
                onClick={handleSwitchMovie}
                data-testid="switch-movie-button"
              >
                <div style={styles.switchMovieButton}></div>
              </div>
            </div>
  
            <div style={{float: 'right'}}>
              {selectFlg === 0 && images.length > 0 && !duringPolling && odIsUploaded === 1 && (
                <div style={styles.imageEdit} onClick={handleOpenImageEdit} data-testid="image-edit-button"></div>
              )}
              {selectFlg === 1 && movies.length > 0 && movieUrl && (
                <div style={styles.imageEdit} onClick={handleOpenImageEdit} data-testid="movie-edit-button"></div>
              )}
              <div style={styles.imageShare} onClick={handleImageShare} data-testid="share-button"></div>
              {objectIdAutoFlg === '0' && (
                <button style={styles.delete} onClick={handleDelete} data-testid="delete-button">
                  削除
                </button>
              )}
            </div>
          </div>
  
          {hozonFolders.filter(folder => folder.imageFolderId !== 0).length > 0 && (
          <div>
            <select 
              id="hozonFolder"
              name="hozonFolder"
              data-testid="hozon-folder-select"
              value={hozonFolder}
              onChange={handleHozonFolderChange}
              style={styles.select}
            >
              <option value="0">未指定</option>
              <option value="99">全選択 ({totalImageCount})</option>
              {hozonFolders.filter(folder => folder.imageFolderId !== 0).map(folder => (
                <option key={folder.imageFolderId} value={folder.imageFolderId}>
                  {folder.imageFolderName} ({folderImageCounts[folder.imageFolderId] || 0})
                </option>
              ))}
            </select>
          </div>
          )}
           </div>
  
        {/* Image Area - 画像モードの時のみ表示 */}
        {selectFlg === 0 && renderImageArea()}
  
        {/* Movie Area - 動画モードの時のみ表示 */}
        {selectFlg === 1 && renderMovieArea()}
  
        {/* Selectors */}
        <div style={styles.selector}>
          {/* カテゴリが未指定(0)のみの場合は非表示 */}
          {satsueiMemoCategories.filter(c => c.satsueiMemoCategoryId !== 0 && c.satsueiMemoCategoryId !== '0').length > 0 && (
            <div style={styles.satsueiMemoCategoryArea}>
              <div style={styles.satsueiMemoCategoryAreaTitle}>
                撮影メモカテゴリー
              </div>
              <select
                id="satsueiMemoCategory"
                name="satsueiMemoCategory"
                data-testid="satsuei-memo-category-select"
                value={String(satsueiMemoCategory)}
                onChange={(e) => handleSatsueiMemoCategoryChange(e.target.value)}
                style={styles.select}
              >
                <option value="0">未指定</option>
                {satsueiMemoCategories
                  .filter(category => category.satsueiMemoCategoryId !== 0 && category.satsueiMemoCategoryId !== '0')
                  .map(category => (
                    <option
                      key={category.satsueiMemoCategoryId}
                      value={String(category.satsueiMemoCategoryId)}
                    >
                      {category.satsueiMemoCategoryName}
                    </option>
                  ))}
              </select>
            </div>
          )}

          {satsueiGuides.length > 0 && (
            <div style={styles.satsueiGuideArea}>
              <div style={styles.satsueiGuideAreaTitle}>
                撮影ガイド
              </div>
              <select
                id="satsueiGuide"
                name="satsueiGuide"
                data-testid="satsuei-guide-select"
                value={satsueiGuide}
                onChange={(e) => setSatsueiGuide(e.target.value)}
                style={styles.select}
              >
                <option value="">使用しない</option>
                {satsueiGuides.map(guide => (
                  <option key={guide.satsueiGuideId} value={guide.satsueiGuideId}>
                    {guide.satsueiGuideName}
                  </option>
                ))}
              </select>
            </div>
          )}

          {/* 拠点が未指定(0)のみの場合は非表示 */}
          {kyotenLists.filter(k => k.kyotenId !== 0 && k.kyotenId !== '0').length > 0 && (
            <div style={styles.kyotenListArea}>
              <div style={styles.kyotenListAreaTitle}>
                拠点
              </div>
              <select
                value={kyoten}
                onChange={(e) => setKyoten(e.target.value)}
                style={styles.select}
                data-testid="kyoten-select"
              >
                <option value="0">未指定</option>
                {kyotenLists
                  .filter(k => k.kyotenId !== 0 && k.kyotenId !== '0')
                  .map(kyoten => (
                    <option key={kyoten.kyotenId} value={kyoten.kyotenId}>
                      {kyoten.kyotenName}
                    </option>
                  ))}
              </select>
            </div>
          )}
        </div>
  
        {/* Memo Area */}
        <div style={styles.satsueiMemoArea}>
          <div style={styles.satsueiMemoAreaTitle} data-testid="satsuei-memo-area-title">
            撮影ラベル
          </div>
          {satsueiMemoColumns.length > 0 ? (
            <SatsueiMemoForm
              objectId={objectId}
              satsueiMemoColumns={satsueiMemoColumns}
              // satsueiMemoColumnDatas={satsueiMemoColumnDatas}
              onChange={setSatsueiMemoFormData}
              onFormChange={setFormChangeFlg}
              onRef={(ref) => {
                satsueiMemoFormRef.current = ref;
              }}
            />
          ) : (
            <div style={{ padding: '20px', textAlign: 'center', color: '#666' }}>
              撮影メモカテゴリーを選択してください
            </div>
          )}
        </div>
  
         {/* Modals */}
         {renderImageEditModal()}
         {renderCopyModal()}
         <ImageTagListModal
           isOpen={showImageTagListModal}
           onClose={async () => {
             setShowImageTagListModal(false);
             // モーダルが閉じられた後に1枚目のタグのみ再読み込み
             if (imageData && imageData.length > 0) {
               const firstImage = imageData[0];
               if (firstImage.objectId !== null && firstImage.objectImageId !== null 
                && firstImage.objectImageId !== undefined && firstImage.objectImageId !== '' ) {
                 await loadImageTags(firstImage.objectId, firstImage.objectImageId, 0);
               }
             }
           }}
           objectId={objectId}
           images={images}
           imageData={imageData}
           onTagsUpdated={handleTagsUpdated}
         />

         <ImageReshootModal
           isOpen={showImageReshootModal}
           onClose={() => setShowImageReshootModal(false)}
           objectId={objectId}
           images={images}
           imageData={imageData}
           currentImageIndex={currentImageIndex}
           onImageReshoot={handleImageReshoot}
           satsueiMemoCategoryId={satsueiMemoCategory}
           objectIdAutoFlg={objectIdAutoFlg}
           userKyotenId={userKyotenId}
           imageFolderId={hozonFolder}
           satsueiGuideId={satsueiGuide}
           backUrl={backUrl}
           isSaveLocal={isSaveLocal}
           thetaCameraUsage={thetaCameraUsage}
         />

         <ImageCaptureFromPositionModal
           isOpen={showImageCaptureFromPositionModal}
           onClose={() => setShowImageCaptureFromPositionModal(false)}
           objectId={objectId}
           images={images}
           imageData={imageData}
           currentImageIndex={currentImageIndex}
           onCaptureFromPosition={handleCaptureFromPosition}
           satsueiMemoCategoryId={satsueiMemoCategory}
           objectIdAutoFlg={objectIdAutoFlg}
           userKyotenId={userKyotenId}
           imageFolderId={hozonFolder}
           satsueiGuideId={satsueiGuide}
           backUrl={backUrl}
           isSaveLocal={isSaveLocal}
           thetaCameraUsage={thetaCameraUsage}
         />

        <ImageDeleteModal
          isOpen={showImageDeleteModal}
          onClose={() => setShowImageDeleteModal(false)}
          objectId={objectId}
          images={images}
          imageData={imageData}
          onImageDeleted={handleImageDeleted}
        />

        <ImageSwapModal
          isOpen={showImageSwapModal}
          onClose={() => setShowImageSwapModal(false)}
          objectId={objectId}
          images={images}
          imageData={imageData}
          onImageSwapped={handleImageSwapped}
        />

        <ImageHandwriteEditModal
          isOpen={showImageHandwriteEditModal}
          onClose={() => setShowImageHandwriteEditModal(false)}
          objectId={objectId}
          imageData={imageData}
          onHandwriteEditComplete={handleHandwriteEditComplete}
        />

        <MovieReshootModal
          isOpen={showMovieReshootModal}
          onClose={() => setShowMovieReshootModal(false)}
          objectId={objectId}
          movies={movies}
          movieData={movieData}
          currentMovieIndex={currentMovieIndex}
          onMovieReshoot={handleMovieReshoot}
          satsueiMemoCategoryId={satsueiMemoCategory}
          objectIdAutoFlg={objectIdAutoFlg}
          userKyotenId={userKyotenId}
          imageFolderId={hozonFolder}
          satsueiGuideId={satsueiGuide}
          backUrl={backUrl}
          isSaveLocal={isSaveLocal}
        />

        <MovieDeleteModal
          isOpen={showMovieDeleteModal}
          onClose={() => setShowMovieDeleteModal(false)}
          objectId={objectId}
          movies={movies}
          movieData={movieData}
          onMovieDeleted={handleMovieDeleted}
        />
        
        <ShareModal
          isOpen={showShareModal}
          onClose={handleShareModalClose}
          shareData={shareData}
        />
        </>
      )}
      
      {/* Fixed Button Area */}
      <div>
        <button style={styles.registMemo} onClick={handleRegistMemo} data-testid="register-button">
          登録
        </button>
        <button style={styles.copyObject} onClick={handleCopyObject} data-testid="copy-button">
          コピー
        </button>
      </div>
      
      {/* Footer - 常に表示 */}
      {memoizedFooter}
      
      {/* Error Dialog */}
      <MessageDialog
        isOpen={showErrorDialog}
        onClose={closeErrorDialog}
        title="エラー"
        message={errorMessage}
        type="error"
      />
    </div>
  );
};

export default AppObjectDetail;
